export const getPrepLessonsDetailsLoadingStatusKey = (courseId: number, lessonsIds: number[]): string => {
    return `${courseId}:${lessonsIds.sort().join(':')}`;
};
